import { useMutation, UseMutationOptions } from "react-query";
import { api, ApiError } from "utils/api";
import { UploadedImage } from "../types";

const getImageUploadUrl = (contentType: string) =>
  api.get<{ url: string }>(`/upload_url?contentType=${contentType}`);

const putImageUpload = async (file: File): Promise<UploadedImage> => {
  const { url } = await getImageUploadUrl(file.type);

  const resp = await fetch(url, {
    method: "PUT",
    body: file,
  });

  if (!resp.ok) {
    throw new ApiError("Image upload failed", resp.status);
  }

  return {
    file,
    // Remove query string from AWS S3 URL
    url: url.indexOf("?") > -1 ? url.slice(0, url.indexOf("?")) : url,
  };
};

const useImageUpload = (
  options?: UseMutationOptions<UploadedImage, unknown, File>
) => {
  const {
    data: upload,
    mutate: runUpload,
    ...uploadQuery
  } = useMutation(putImageUpload, options);

  return {
    runUpload,
    upload,
    ...uploadQuery,
  };
};

export { useImageUpload };
